let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fZuIT")).then(() => parcelRequire('gBJum'));